/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Jayati_Quote_P1Inputs */

const en_marketing_app_jayati_quote_p1 = /** @type {(inputs: Marketing_App_Jayati_Quote_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Having an app that converts `)
};

const es_marketing_app_jayati_quote_p1 = /** @type {(inputs: Marketing_App_Jayati_Quote_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tener una app que convierte `)
};

/**
* | output |
* | --- |
* | "Having an app that converts" |
*
* @param {Marketing_App_Jayati_Quote_P1Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_jayati_quote_p1 = /** @type {((inputs?: Marketing_App_Jayati_Quote_P1Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Jayati_Quote_P1Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_jayati_quote_p1(inputs)
	return en_marketing_app_jayati_quote_p1(inputs)
});